<template>
  <v-card class="mt-3">
    <v-toolbar flat density="compact" color="transparent" height="100%">
      <v-row class="fill-height align-center">
        <v-col cols="6">
          <v-text-field
            v-model="search"
            clear-icon="mdi-close"
            append-inner-icon="mdi-magnify"
            label="Recherche"
            @keyup.enter="searchTrigger"
            @click:append-inner="searchTrigger"
            @click:clear="handleClearSearch"
            :error-messages="getErrorMessage"
            :error="searchError"
            :persistent-hint="showHint"
            :hint="hintText"
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-data-table-server
      :headers="headers"
      :items="materials"
      :items-per-page-options="[10, 25, 50, 100, 500]"
      :loading="loadingData"
      :no-data-text="noDataText"
      :items-length="totalItems"
      :items-per-page-text="rowsPerPageText"
      page-text="Lignes {0} - {1} de {2}"
      v-model:options="options"
    >
      <template v-slot:item="props">
        <tr @click="onItemSelect(props.item)">
          <td>
            <v-checkbox
              true-icon="mdi-checkbox-marked"
              false-icon="mdi-checkbox-blank-outline"
              v-model="props.item.selected"
              color="primary"
              hide-details
            ></v-checkbox>
          </td>
          <td>{{ props.item.materialName }}</td>
        </tr>
      </template>
    </v-data-table-server>
    <v-snackbar v-model="showError" :timeout="6000" color="error" y="bottom">
      {{ nameError }}
      <v-btn variant="text" @click="showError = false">Fermer</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { GetAllPagingMaterialsFromComposite, GetSearchMaterial } from '@/_services/composites';
import { paginationMixin } from '@/classes/helper/paginationHelper';

export default {
  name: 'CompositeList',
  mixins: [paginationMixin],
  props: {
    composite: {
      type: Object,
    },
    materialToDeselect: {
      type: Object,
    },
    allSelectedMaterials: {
      type: Array,
    },
    activeTab: {
      type: Number,
    },
  },
  data() {
    return {
      compositeProp: null,
      selectedCustomMaterials: [],
      totalItems: 0,
      search: '',
      oldSearch: '',
      searchError: false,
      showHint: true,
      hintText: 'Appuyer sur la touche {enter} ou sur la loupe pour rechercher.',
      noDataText: 'Aucune donnée pour le moment.',
      noResultsText: 'Chargement des matériaux.',
      rowsPerPageText: 'Éléments par page',
      materials: [],
      loadingData: false,
      alertData: false,
      outline: true,
      alertColor: 'info',
      alertIcon: 'info',
      headers: [
        {
          title: '',
          align: 'start',
          key: 'column-0',
          sortable: false,
          width: '50',
        },
        {
          title: 'Nom',
          align: 'start',
          key: 'name',
          sortable: false,
        },
      ],
      nameError: 'Une erreur est survenue, veuillez vérifier vos informations et réessayer.',
      showError: false,
    };
  },
  computed: {
    getErrorMessage() {
      if (this.searchError) {
        return this.noDataText;
      }
      return '';
    },
  },
  methods: {
    getDataFromApi() {
      this.showAlert('', 'info');
      this.loadingData = true;
      const { page, rowsPerPage } = this.pagination;

      //todo: GetMaterialsFromComposite doit avoir de la pagination
      GetAllPagingMaterialsFromComposite(this.compositeProp.compositePrototypeId, rowsPerPage, (page - 1) * rowsPerPage)
        .then(rep => {
          this.materials = rep.data.items;
          this.totalItems = rep.data.totalItems;
          this.loadingData = false;
          this.showHint = true;
        })
        .catch(() => {
          this.error = true;
          this.materials = [];
          this.search = '';
          this.oldSearch = '';
          this.showAlert('', 'error');
        })
        .finally(() => {
          this.setSelectedMaterials();
        });
    },
    searchTrigger() {
      if (this.oldSearch === this.search) {
        return;
      }
      this.searchError = false;
      this.oldSearch = this.search;
      if (this.search) {
        this.$nextTick(() => this.getSearch());
      } else {
        this.getDataFromApi();
      }
    },

    handleClearSearch() {
      this.oldSearch = null;
      this.searchError = false;
      this.$nextTick(() => this.getDataFromApi());
    },
    showAlert(msg, alertType) {
      this.alertData = false;
      switch (alertType) {
        case 'info':
          this.outline = true;
          this.alertColor = 'info';
          this.alertIcon = 'info';
          this.noDataText = 'Aucune donnée pour le moment.';
          break;
        case 'warning':
          this.outline = false;
          this.alertColor = 'orange';
          this.alertIcon = 'warning';
          this.noDataText = `Votre recherche pour "${this.search.trim()}" n'a retourné aucun résultat.`;
          this.error = true;
          break;
        case 'error':
          this.outline = false;
          this.alertColor = 'error';
          this.alertIcon = 'error';
          this.noDataText = 'Une erreur est survenue. Veuillez réessayer.';
          this.error = true;
          break;
        default:
          break;
      }
      if (msg.trim() !== '') {
        this.noDataText = msg;
      }
      this.alertData = true;
    },
    getSearch() {
      this.loadingData = true;
      this.error = false;
      let searchParam = this.search.trim();

      const { page, rowsPerPage } = this.pagination;
      GetSearchMaterial(this.compositeProp.compositePrototypeId, searchParam, rowsPerPage, (page - 1) * rowsPerPage)
        .then(rep => {
          this.alertData = false;
          this.materials = rep.items;
          this.totalItems = rep.totalItems;
          this.loadingData = false;
          this.searchError = false;
          if (this.totalItems === 0) {
            this.error = true;
            this.showAlert('', 'warning');
            this.searchError = true;
          }
        })
        .catch(() => {
          if (page > 1) {
            GetSearchMaterial(this.compositeProp.compositePrototypeId, searchParam, rowsPerPage, 0)
              .then(rep => {
                this.alertData = false;
                this.materials = rep.items;
                this.totalItems = rep.totalItems;
                this.loadingData = false;
                this.searchError = false;
                if (this.totalItems === 0) {
                  this.error = true;
                  this.showAlert('', 'warning');
                  this.searchError = true;
                }
              })
              .catch(() => {
                this.error = true;
                this.materials = [];
                this.search = '';
                this.oldSearch = '';
                this.showAlert('', 'error');
              });
          } else {
            this.error = true;
            this.materials = [];
            this.search = '';
            this.oldSearch = '';
            this.showAlert('', 'error');
          }
        })
        .finally(() => {
          this.setSelectedMaterials();
        });
    },
    setSelectedMaterials() {
      this.materials = this.materials.map(x => ({
        ...x,
        selected: Boolean(this.isMaterialSelected(x)),
      }));
    },
    isMaterialSelected(material) {
      return this.allSelectedMaterials.find(
        x => x.compositeMaterialPrototypeId === material.compositeMaterialPrototypeId,
      );
    },
    onItemSelect(material) {
      material.selected = !material.selected;
      if (material.selected) {
        this.$emit('add-material', { material, type: 'composite' });
      } else {
        this.$emit('remove-material', { material, type: 'composite' });
      }
    },
  },
  mounted() {
    if (this.composite.compositePrototypeId) {
      this.compositeProp = this.composite;
      this.getDataFromApi();
    }
  },
  watch: {
    activeTab(tabNumber) {
      if (tabNumber === 0 && this.compositeProp) {
        this.getDataFromApi();
      }
    },
    pagination: {
      handler(oldval, newval) {
        if (oldval.page !== newval.page || oldval.rowsPerPage !== newval.rowsPerPage) {
          if (this.search.trim().length < 3) {
            this.getDataFromApi();
          } else {
            this.getSearch();
          }
        }
      },
      deep: true,
    },
    materialToDeselect(newVal) {
      const material = this.materials.find(x => x.compositeMaterialPrototypeId === newVal.compositeMaterialPrototypeId);
      const index = this.materials.indexOf(material);
      if (index !== -1) {
        this.materials[index].selected = false;
      }
    },
  },
};
</script>
